module.exports = __webpack_public_path__ + "img/c04_unitfishingboat_Normal_ua.86158294.webp";